import UAParser from 'ua-parser-js'

export async function getIpAndBrowser() {
  const parser = new UAParser()
  const browser = parser.getBrowser().name

  const ip = await fetch('https://api.ipify.org?format=json')
    .then(res => res.json())
    .then(data => data.ip)
    .catch(() => null)

  return {
    ip,
    browser,
  }
}
